import { render, staticRenderFns } from "./CitiesToday.vue?vue&type=template&id=10fea024&"
import script from "./CitiesToday.vue?vue&type=script&lang=js&"
export * from "./CitiesToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports